<h2 *ngIf="data?.nbOfPipelines > 0; else stopRestartDisabled" mat-dialog-title [innerHtml]="('MODAL.title.piper.' + data.action) | translate: {nbOfPipelines: data.nbOfPipelines}"></h2>
<mat-dialog-actions>
  <ng-container *ngIf="data.nbOfPipelines && data.nbOfPipelines > 0">
    <button type="button" (click)="closeDialog(ModalResponse.CLICK_ACCEPT)">{{'GLOBAL.yes' | translate }}</button>
    <button type="button" (click)="closeDialog(ModalResponse.CLICK_CLOSE)">{{'GLOBAL.no' | translate }}</button>
  </ng-container>
  <ng-container *ngIf="data.nbOfPipelines === 0">
    <button type="button" (click)="closeDialog(ModalResponse.CLICK_CLOSE)">{{'GLOBAL.close' | translate }}</button>
  </ng-container>
</mat-dialog-actions>

<ng-template #stopRestartDisabled>
  <h2 mat-dialog-title [innerHtml]="('MODAL.title.piper.actionDisabled.' + data.action) | translate"></h2>
</ng-template>
